import { graphql } from "relay-runtime"
import { dePatientByIdQuery$data } from "@/modules/patients/services/de/__generated__/dePatientByIdQuery.graphql"

const dePatientByIdQuery = graphql`
  query dePatientByIdQuery($patientId: ID!, $appointmentId: ID) {
    patientById: de_patientById(id: $patientId) {
      __typename
      ...PatientFragment
      ...PatientFragmentInline

      ...submitBtnAgendaTeleconsultationPatientFragment

      id
      patientId
      medgateServiceInfo {
        externalAssistanceServiceInfo {
          name
        }
        genericsObligation
        betterDoc
        hasBetterDocConditionPackage
        isMedgateTeleGeneralPractitioner
        isMedicalChatEnabled
        referralToGeneralPractitioner
        referralToSpecialist
        hasInsuranceListReferralToGeneralPractitioner
        hasInsuranceListReferralToSpecialist
        isEligibleToPartnerPortal
      }
      emailAddress
      phoneNumber
      callerPhoneNumbers
      contactChannel
      contactChannelUpdatedAt
      createdAt
      emailVerification {
        ...deEmailVerificationFragment @relay(mask: false)
      }
      preventionPrograms(first: null) @connection(key: "PatientPreventionProgramsConnection_preventionPrograms") {
        edges {
          cursor
          node {
            ...PatientPreventionProgramOutputFragment @relay(mask: false)
          }
        }
      }
      address {
        ...PatientHomeAddressFragment @relay(mask: false)
      }
      contextAppointment: appointment(id: $appointmentId) {
        ...PatientContextAppointmentFragment
      }
      healthInformationVerifications(appointmentId: $appointmentId) {
        appointmentId
        healthInformationType
        id
        patientId
        verifiedAt
        verifiedBy
      }
      healthInformationLastVerification {
        healthInformationType
        id
        patientId
        verifiedAt
        verifiedBy
      }
      caveEntry {
        message
        updatedAt
        updatedBy
      }
      insurees {
        ...dePatientInsureesFragment @relay(mask: false)
      }
      conditionInformation {
        ...PatientConditionInformationOutputFragment
      }
      gynaecology {
        ...GynaecologyFragment
      }
      allergiesInformation {
        ...PatientAllergiesOutputFragment
      }
      familyHistory {
        ...FamilyHistoryFragment
      }
      socialHistory {
        ...SocialHistoryFragment
      }
      bodyMeasurements(first: null) @connection(key: "PatientByIdConnection_bodyMeasurements") {
        edges {
          ...PatientBodyMeasurementsOutputFragment
          ...PatientBodyMeasurementsOutputFragmentInline
        }
      }
      medications: de_medications(first: null) @connection(key: "DePatientByIdConnection_de_medications") {
        edges {
          node {
            id
            startDate
            endDate
            pharmaceuticalCentralNumber
            ...deMedicationFragment
            ...deMedicationFragmentInline
          }
        }
      }
      account {
        ...deAccountFragment @relay(mask: false)
      }
      duplicateOfPatient {
        id
      }
      hasUpcomingPlannedAppointment
      teleGpOnboardingPerformed
    }
  }
`

type DeInsurees = NonNullable<dePatientByIdQuery$data["patientById"]>["insurees"]

type DeInsuree = NonNullable<dePatientByIdQuery$data["patientById"]>["insurees"][number]

type DeMedgateServiceInfo = NonNullable<dePatientByIdQuery$data["patientById"]>["medgateServiceInfo"]

export { dePatientByIdQuery as de_PatientByIdQuery, type DeInsurees, type DeInsuree, type DeMedgateServiceInfo }
